import _ from './utility';

function comments(){	
	document.addEventListener('vfCommentCount', _.lastVisibleByline);
}

export default _.catch(comments);